module.exports = __webpack_public_path__ + "img/dummyprod9@2x.20227f4c.png";